/**
 * https://github.com/redux-observable/redux-observable/issues/94#issuecomment-283228607
 * https://github.com/PlatziDev/redux-catch
 */

export function createCatchMiddleware(errorHandler) {
  return function(store) {
    return function(next) {
      return function(action) {
        try {
          return next(action);
        } catch (err) {
          errorHandler(err, store.getState, action, store.dispatch);
          return err;
        }
      };
    };
  };
}
